import "./App.css";
import React, { useEffect, useState } from "react";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import { MantineProvider } from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";
import { useNavigate, Routes, Route, BrowserRouter } from "react-router-dom";
import StorageService from "./services/StorageService";
import Logout from "./components/Logout";
import NewDashboard from "./components/appointments/NewDashboard";
import CreateAppointment from "./components/appointments/CreateAppointment";
import ViewAppointments from "./components/appointments/ViewAppointments";
const storageService = new StorageService();

export const authCheck = async (): Promise<boolean> => {
  let token = storageService.get("token");
  return token !== null;
};

const Protected = ({ path, isLoggedIn, children, redirect }: any) => {
  const navigate = useNavigate();

  useEffect(() => {
    isLoggedIn.then((b: any) => {
      if (!b) {
        navigate(redirect);
      }
    });
  }, [isLoggedIn, navigate, redirect]);

  return children;
};

function App() {
  return (
    <NotificationsProvider position="bottom-right" zIndex={9999}>
      <BrowserRouter>
        <div>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />

            <Route
              path="/"
              element={
                <Protected path="/" redirect="/login" isLoggedIn={authCheck()}>
                  <MantineProvider withNormalizeCSS withGlobalStyles>
                    {/* <Dashboard /> */}
                    <NewDashboard />
                  </MantineProvider>
                </Protected>
              }
            ></Route>
            <Route
              path="/create"
              element={
                <Protected
                  path="/create"
                  redirect="/login"
                  isLoggedIn={authCheck()}
                >
                  <MantineProvider withNormalizeCSS withGlobalStyles>
                    <CreateAppointment />
                  </MantineProvider>
                </Protected>
              }
            ></Route>
            <Route
              path="/view"
              element={
                <Protected
                  path="/view"
                  redirect="/login"
                  isLoggedIn={authCheck()}
                >
                  <MantineProvider withNormalizeCSS withGlobalStyles>
                    <ViewAppointments />
                  </MantineProvider>
                </Protected>
              }
            ></Route>
          </Routes>
        </div>
      </BrowserRouter>
    </NotificationsProvider>
  );
}

export default App;
